import { Navigate } from 'react-router-dom';
import { useHasPermission } from '@aegix/auth-permissions';
import { DeliveryMetrics } from '../pages';

/**
 * Standalone, bookmarkable admin page for notification delivery
 * metrics (ADR-041 Phase 5). Renders `<DeliveryMetrics />` in its
 * non-embedded (default) mode, so it carries its own PageHeader and
 * time-window selector.
 *
 * Gated by the SAME admin permission as the embedded Dashboard tab
 * (`notifications.admin_fcm_device_token`) — no new permission or
 * role wiring. Non-admins are redirected to the dashboard, mirroring the
 * `FeatureGate` redirect convention. The enclosing `PrivateRoute` already
 * gates on auth hydration, so by the time this renders the user (and its
 * `permissions`) is settled and `useHasPermission` is reliable.
 */
const DELIVERY_METRICS_PERMISSION = 'notifications.admin_fcm_device_token';

export function DeliveryMetricsRoute() {
  const canViewDeliveryMetrics = useHasPermission(DELIVERY_METRICS_PERMISSION);

  if (!canViewDeliveryMetrics) {
    return <Navigate to="/" replace />;
  }

  return <DeliveryMetrics />;
}
